<template>
  <div class="panel-body">
    <div class="banner-option border-bottom">
      <app-option-editor
        :data-title="$t('message.campaigns.message.button')"
        :data-interaction="interactionStored"
        :data-option="interactionStored.opcoes[0]"
        :data-max-length="22"
        @change="
          (evt) =>
            $emit('update-option', {
              option: interactionStored.opcoes[0],
              data: { nome: evt },
            })
        "
        @change-auth="
          (evt) =>
            $emit('update-option', {
              option: interactionStored.opcoes[0],
              data: { paginaPosAutenticacao: evt },
            })
        "
      >
      </app-option-editor>
      <div class="video-configuration-section">
        <div class="btn-inpt">
          <app-form
            @submit="emitForm"
            class="video-configuration-section-form"
            ref="form"
          >
            <section
              v-if="userCanUploadVideo || interactionHasCloudflareVideoSet"
              class="video-configuration-section-form-source-type"
            >
              <div class="minimum-time-card">
                <span><strong>Tipo de Vídeo</strong></span>
                <v-radio-group
                  v-model="form.isCloudflareVideo"
                  class="video-type-radio-group"
                >
                  <div class="video-type-radio-group-item">
                    <v-radio :value="false"></v-radio>
                    <span>URL</span>
                  </div>
                  <div class="video-type-radio-group-item">
                    <v-radio
                      :value="true"
                      :disabled="
                        interactionHasCloudflareVideoSet && !userCanUploadVideo
                      "
                    ></v-radio>
                    <span>Arquivo</span>
                  </div>
                </v-radio-group>
              </div>
            </section>

            <section
              v-if="isCloudflareVideo"
              class="video-configuration-section-form-source-select"
            >
              <button
                class="btn btn-sm btn-extra-round"
                type="button"
                :disabled="
                  interactionHasCloudflareVideoSet && !userCanUploadVideo
                "
                @click="openVideoUploadModal('mobile')"
              >
                <i class="mdi mdi-cellphone" />
                <span>
                  {{ selectMobileVideoButtonLabel }}
                </span>
              </button>
              <button
                class="btn btn-sm btn-extra-round"
                type="button"
                :disabled="
                  interactionHasCloudflareVideoSet && !userCanUploadVideo
                "
                @click="openVideoUploadModal('desktop')"
              >
                <i class="mdi mdi-laptop" />
                <span>
                  {{ selectDesktopVideoButtonLabel }}
                </span>
              </button>
            </section>

            <section v-else>
              <text-field
                label="Link do Video para Celular"
                name="Link do Video para Celular"
                v-model="form.mediaMobile"
                validate="required"
                :error-messages="errors.collect('Link do Video para Celular')"
              ></text-field>
              <text-field
                label=" Link do Video para Computador"
                v-model="form.mediaDesktop"
              ></text-field>
            </section>

            <section>
              <div class="minimum-time-card">
                <strong>Tempo de exibição de campanha</strong>
                <div>
                  <span>Exibir por no mínimo</span>
                  <input
                    v-model="form.minimumTime"
                    maxlength="2"
                    class="minimum-time-input"
                  />
                  <span>segundos</span>
                </div>
              </div>
              <span
                v-if="minimumTimeError"
                class="text-danger minimum-time-error"
                v-html="minimumTimeError"
              ></span>
            </section>

            <button
              @click="$refs.form.validate()"
              class="btn btn-primary btn-round video-configuration-section-form-submit-button"
              :disabled="Boolean(minimumTimeError)"
            >
              Salvar
            </button>
          </app-form>
        </div>
      </div>
    </div>
    <video-modal
      v-if="isVideoUploadModalOpen"
      v-model="isVideoUploadModalOpen"
      :type="videoUploadModalType"
      :selected-video-mobile-id="selectedVideoMobileId"
      :selected-video-desktop-id="selectedVideoDesktopId"
      @on-selected-video="setSelectedVideo"
    >
    </video-modal>
  </div>
</template>

<script>
import AppOptionEditor from "./OptionEditor";
import panelBody from "../mixins/panel-body";
import TextField from "@components/form/TextField.vue";
import AppForm from "@components/form/Form.vue";
import VideoModal from "./video/modal/VideoModal.vue";

export default {
  components: {
    AppOptionEditor,
    TextField,
    AppForm,
    VideoModal,
  },

  props: {
    video: {
      type: Boolean,
    },
  },

  data() {
    return {
      minimumTimeError: "",
      form: {
        minimumTime: undefined,
        mediaMobile: undefined,
        mediaDesktop: undefined,
        isCloudflareVideo: false,
        videoMobile: undefined,
        videoDesktop: undefined,
      },
      isVideoUploadModalOpen: false,
      videoUploadModalType: undefined,
      selectedMobileVideoName: undefined,
      selectedDesktopVideoName: undefined,
    };
  },

  watch: {
    watch: {
      form: {
        handler({ minimumTime }) {
          this.minimumTimeError = "";

          if (!minimumTime) return;

          if (/[.,]/g.test(minimumTime)) {
            this.minimumTimeError = "O tempo mínimo deve ser um valor inteiro.";
          }

          const numberMinimumTime = Number(minimumTime);
          if (numberMinimumTime > 60) {
            this.minimumTimeError =
              "O limite para campanha de vídeo é de <b>60</b> segundos.";
          }

          if (numberMinimumTime < 0) {
            this.form.minimumTime = 0;
          }
        },
        deep: true,
      },
    },
  },

  computed: {
    maxLength() {
      return this.interaction.opcoes.length === 1 ? 22 : 12;
    },
    media() {
      return this.interaction.mediaMobile;
    },
    isCloudflareVideo() {
      return this.form.isCloudflareVideo;
    },
    permissions() {
      return this.$store.state.users.user.permissions;
    },
    userCanUploadVideo() {
      return !!this.permissions.find((x) => x === "ALLOW_VIDEO_UPLOAD");
    },
    selectMobileVideoButtonLabel() {
      return this.selectedMobileVideoName || "Selecione vídeo para celular";
    },
    selectDesktopVideoButtonLabel() {
      return this.selectedDesktopVideoName || "Selecione vídeo para computador";
    },
    selectedVideoMobileId() {
      return this.form.videoMobile || undefined;
    },
    selectedVideoDesktopId() {
      return this.form.videoDesktop || undefined;
    },
    interactionHasCloudflareVideoSet() {
      return this.interaction.videoMobile && this.interaction.videoMobile.id;
    },
  },

  methods: {
    emitForm() {
      if (this.form.minimumTime === "") {
        this.minimumTimeError = "Coloque um valor válido entre 0 e 60.";
        return;
      }
      const data = {
        minimumTime: this.form.minimumTime,
        mediaMobile: this.form.mediaMobile,
        mediaDesktop: this.form.mediaDesktop,
        isCloudflareVideo: this.form.isCloudflareVideo,
        videoMobile: this.form.videoMobile,
        videoDesktop: this.form.videoDesktop,
        tipo: "VIDEO",
      };
      if (data.isCloudflareVideo) {
        data.mediaMobile = null;
        data.mediaDesktop = null;
        this.form.mediaMobile = undefined;
        this.form.mediaDesktop = undefined;
      } else {
        data.videoMobile = undefined;
        data.videoDesktop = undefined;
        this.selectedMobileVideoName = undefined;
        this.selectedDesktopVideoName = undefined;
      }
      this.$emit("input", data);
    },
    setInitialData() {
      this.form = {
        isCloudflareVideo: this.interaction.isCloudflareVideo,
        videoMobile:
          this.interaction.videoMobile && this.interaction.videoMobile.id,
        videoDesktop:
          this.interaction.videoDesktop && this.interaction.videoDesktop.id,
        minimumTime: this.interaction.minimumTime === undefined ? 10 : this.interaction.minimumTime,
        mediaMobile: this.interaction.mediaMobile,
        mediaDesktop: this.interaction.mediaDesktop,
      };
      if (this.interaction.isCloudflareVideo) {
        this.selectedMobileVideoName =
          this.interaction.videoMobile && this.interaction.videoMobile.name;
        this.selectedDesktopVideoName =
          this.interaction.videoDesktop && this.interaction.videoDesktop.name;
      }
    },
    openVideoUploadModal(type) {
      this.videoUploadModalType = type;
      this.isVideoUploadModalOpen = true;
    },
    setSelectedVideo(val) {
      if (val.type === "mobile") {
        this.form.videoMobile = val.selectedVideoId;
        this.selectedMobileVideoName = val.selectedVideoName;
      } else {
        this.form.videoDesktop = val.selectedVideoId;
        this.selectedDesktopVideoName = val.selectedVideoName;
      }
    },
  },

  mounted() {
    this.setInitialData();
  },

  mixins: [panelBody],
};
</script>

<style lang="scss" scoped>
@import "../mixins/panel-body";

.video-configuration-section {
  margin-top: 30px;

  .video-configuration-section-form {
    display: flex;
    flex-direction: column;

    .video-type-radio-group {
      margin-top: 0;
      padding-top: 0;

      ::v-deep .v-input__slot {
        margin-bottom: 0;
      }

      ::v-deep .v-input--radio-group__input {
        display: flex;
        flex-direction: row;
        gap: 28px;

        .video-type-radio-group-item {
          display: flex;
        }
      }
      ::v-deep .v-radio {
        margin: 0;
      }
      ::v-deep .v-input--selection-controls__input {
        margin-right: 4px;
      }
    }

    .video-configuration-section-form-source-select {
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin: 16px 0;

      button {
        display: flex;
        align-items: center;

        span {
          margin: 0 auto;
        }

        .mdi {
          font-size: 24px;
        }
      }
    }

    .video-configuration-section-form-submit-button {
      align-self: center;
      margin-top: 15px;
    }
  }
}

.minimum-time-card {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  gap: 8px;
  margin-top: 8px;
}

.minimum-time-input {
  padding: 2px;
  border-bottom: 1px solid black;
  max-width: 32px;
  margin-inline: 8px;
  text-align: center;
  font-size: 14px;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    outline: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
}

.minimum-time-error {
  font-size: 12px;
}
</style>
